import { __rest } from '../../../_virtual/_tslib.js';
import React from 'react';
import PropTypes from 'prop-types';
import { INPUT_FIELD_TYPES } from './types.js';

const InputField = /*#__PURE__*/React.forwardRef((_a, ref) => {
  var {
      id,
      className,
      valid,
      busy = false,
      type = 'text'
    } = _a,
    rest = __rest(_a, ["id", "className", "valid", "busy", "type"]);
  return /*#__PURE__*/React.createElement("input", Object.assign({
    ref: ref,
    id: id,
    type: type,
    className: className
  }, valid !== undefined && type !== 'radio' && {
    'aria-invalid': !valid
  }, busy && {
    'aria-busy': true
  }, rest));
});
InputField.displayName = 'InputField';
InputField.propTypes = {
  id: PropTypes.string.isRequired,
  valid: PropTypes.bool,
  busy: PropTypes.bool,
  type: PropTypes.oneOf(INPUT_FIELD_TYPES)
};

export { InputField, InputField as default };
